import { useState, useEffect } from "react";

import { API_URL, createMarkup } from "../helpers";

import Hdg2 from "../components/Hdg2";
import Nav from "../components/Nav";
import Alert from "../components/Alert";

const Overview = () => {
	const [html, setHtml] = useState({});
	const [alert, setAlert] = useState({
		type: "working",
		text: "",
	});

	useEffect(() => {
		init();
	}, []);

	const init = async () => {
		const url = new URL(`${API_URL}/htmlInit`);
		const params = {
			left: `overview`,
			right: `right`,
		};
		url.search = new URLSearchParams(params);

		try {
			const response = await fetch(url, {
				method: "GET",
				cache: "no-store",
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				setHtml({
					left: json.left,
					right: json.right,
				});
				setAlert({});
				window.jQuery(".cycle-slideshow").cycle("stop");
				window.jQuery(".cycle-slideshow").cycle();
			} else {
				setAlert({
					type: json.resp === 2 ? "notice" : "error",
					text: json.text,
				});
			}
		} catch (error) {
			setAlert({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	return (
		<>
			{alert.type ? (
				<Alert data={alert} />
			) : (
				<>
					<div id="left-column">
						<Hdg2 />

						<div className="blocktext">
							<p>
								Please join us in our annual Valero Benefit for Children event
								to raise funds for children’s charities across the U.S. Your
								consideration of a sponsorship in support of this year’s
								campaign is sincerely appreciated and has lasting impact for
								thousands of children.
							</p>

							<p>
								For more information and to register, please email{" "}
								<a href="mailto:ValeroBFC@valero.com">ValeroBFC@valero.com</a>.
							</p>
						</div>

						<Nav />

						<div dangerouslySetInnerHTML={createMarkup(html.left)} />
					</div>

					<div
						id="right-column"
						dangerouslySetInnerHTML={createMarkup(html.right)}
					/>
				</>
			)}
		</>
	);
};

export default Overview;
